import {CALL_API} from 'redux-api-middleware';
import {ENDPOINT_VENDOR} from 'common/endpoints';
import {
  API_VENDOR_GET_REQUEST,
  API_VENDOR_GET_SUCCESS,
  API_VENDOR_GET_FAILURE,
  API_SAMGOV_GET_REQUEST,
  API_SAMGOV_GET_SUCCESS,
  API_SAMGOV_GET_FAILURE,
} from 'common/types';
import {commonJwtHeader} from 'common/utils';

export default {
  getVendorInfoForDuns: (token, duns) => {
    const endpointToUse = `${ENDPOINT_VENDOR}?duns=${duns}`;
    return {
      [CALL_API]: {
        endpoint: endpointToUse,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [API_VENDOR_GET_REQUEST, API_VENDOR_GET_SUCCESS, API_VENDOR_GET_FAILURE],
      },
    };
  },
  getSamgovInfoForDuns: (token, duns) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_VENDOR}samgovCheck?duns=${duns}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [API_SAMGOV_GET_REQUEST, API_SAMGOV_GET_SUCCESS, API_SAMGOV_GET_FAILURE],
      },
    };
  },
  getSamgovInfoForUei: (token, uei) => {
    const endpointToUse = `${ENDPOINT_VENDOR}samgovCheck?uei=${uei}`;
    return {
      [CALL_API]: {
        endpoint: endpointToUse,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [API_SAMGOV_GET_REQUEST, API_SAMGOV_GET_SUCCESS, API_SAMGOV_GET_FAILURE],
      },
    };
  },
  getSamgovInfoForUeiAndEft: (token, uei, eft) => {
    const endpointToUse = `${ENDPOINT_VENDOR}samgovCheck?uei=${uei}&eft=${eft}`;
    return {
      [CALL_API]: {
        endpoint: endpointToUse,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [API_SAMGOV_GET_REQUEST, API_SAMGOV_GET_SUCCESS, API_SAMGOV_GET_FAILURE],
      },
    };
  },
  getVendorInfoForUei: (token, uei) => {
    const endpointToUse = `${ENDPOINT_VENDOR}?uei=${uei}`;
    return {
      [CALL_API]: {
        endpoint: endpointToUse,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [API_VENDOR_GET_REQUEST, API_VENDOR_GET_SUCCESS, API_VENDOR_GET_FAILURE],
      },
    };
  },
  getVendorInfoForUeiAndEft: (token, uei, eft) => {
    const endpointToUse = `${ENDPOINT_VENDOR}?uei=${uei}&eft=${eft}`;
    return {
      [CALL_API]: {
        endpoint: endpointToUse,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [API_VENDOR_GET_REQUEST, API_VENDOR_GET_SUCCESS, API_VENDOR_GET_FAILURE],
      },
    };
  },
};
